<template>
  <div class="row">
    <!-- Header -->
    <div class="col-12 mb-4">
      <div class="d-flex align-items-center justify-content-between flex-wrap">
        <div>
          <button @click="back" class="btn btn-sm btn-outline-secondary mb-2">
            <i class="mdi mdi-arrow-left mr-1"></i>{{ $t('common.back') }}
          </button>
          <h2 class="text-white font-weight-bold mb-1">{{ $t('superadmin.editCompany') }}</h2>
          <p class="text-muted small mb-0">{{ $t('superadmin.subtitle') }}</p>
        </div>
      </div>
    </div>

    <div class="col-12 grid-margin">
      <div class="card border-0 shadow-sm" style="background: #191c24; border-radius: 12px;">
        <div class="card-body p-4">
          <form class="forms-sample" @submit.prevent="submitForm" enctype="multipart/form-data">
            <!-- Enterprise Profile Section -->
            <h5 class="text-white font-weight-bold mb-3 d-flex align-items-center">
              <i class="mdi mdi-office-building text-warning mr-2"></i>
              {{ $t('superadmin.companyInfo') }}
            </h5>

            <div class="row mb-3">
              <div class="col-md-6 mb-3">
                <label class="text-light small font-weight-bold" for="companyName">
                  {{ $t('superadmin.companyName') }} <span class="text-danger">*</span>
                </label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text bg-dark border-secondary text-muted"><i class="mdi mdi-domain"></i></span>
                  </div>
                  <input
                    type="text"
                    class="form-control bg-dark text-white border-secondary"
                    id="companyName"
                    v-model="ownerStore.companyName"
                    required
                  />
                </div>
              </div>

              <div class="col-md-6 mb-3">
                <label class="text-light small font-weight-bold" for="ownerName">
                  {{ $t('superadmin.ownerName') }} <span class="text-danger">*</span>
                </label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text bg-dark border-secondary text-muted"><i class="mdi mdi-account-tie"></i></span>
                  </div>
                  <input
                    type="text"
                    class="form-control bg-dark text-white border-secondary"
                    id="ownerName"
                    v-model="ownerStore.ownerName"
                    required
                  />
                </div>
              </div>
            </div>

            <div class="row mb-4">
              <div class="col-md-6 mb-3">
                <label class="text-light small font-weight-bold" for="emailAddress">
                  {{ $t('superadmin.registeredEmail') }} <span class="text-danger">*</span>
                </label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text bg-dark border-secondary text-muted"><i class="mdi mdi-email-outline"></i></span>
                  </div>
                  <input
                    type="email"
                    class="form-control bg-dark text-white border-secondary"
                    id="emailAddress"
                    v-model="ownerStore.emailAddress"
                    required
                  />
                </div>
              </div>

              <div class="col-md-6 mb-3">
                <label class="text-light small font-weight-bold" for="phoneNumber">
                  {{ $t('superadmin.phoneNumber') }}
                </label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text bg-dark border-secondary text-muted"><i class="mdi mdi-phone"></i></span>
                  </div>
                  <input
                    type="tel"
                    class="form-control bg-dark text-white border-secondary"
                    id="phoneNumber"
                    v-model="ownerStore.phoneNumber"
                  />
                </div>
              </div>
            </div>

            <!-- Security & Logo Section -->
            <h5 class="text-white font-weight-bold mb-3 d-flex align-items-center">
              <i class="mdi mdi-shield-key-outline text-warning mr-2"></i>
              {{ $currentLocale === 'id' ? 'Keamanan & Identitas Brand' : 'Security & Branding' }}
            </h5>

            <div class="row mb-4">
              <div class="col-md-6 mb-3">
                <label class="text-light small font-weight-bold" for="updatePassword">
                  {{ $t('makerForm.updatePassword') }}
                </label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text bg-dark border-secondary text-muted"><i class="mdi mdi-lock-outline"></i></span>
                  </div>
                  <input
                    type="password"
                    class="form-control bg-dark text-white border-secondary"
                    id="updatePassword"
                    v-model="ownerStore.password"
                    :placeholder="$t('makerForm.leaveBlankPassword')"
                  />
                </div>
                <small class="text-muted">{{ $currentLocale === 'id' ? 'Isi kata sandi baru hanya jika klien meminta reset kredensial.' : 'Enter a new password only if the client requested a credential reset.' }}</small>
              </div>

              <div class="col-md-6 mb-3">
                <label class="text-light small font-weight-bold">
                  {{ $t('superadmin.companyLogo') }}
                </label>
                <div class="d-flex align-items-center">
                  <div
                    v-if="owner && owner.company && owner.company.logo"
                    class="mr-3 p-1 rounded bg-black d-flex align-items-center justify-content-center"
                    style="width: 60px; height: 60px; border: 1px solid rgba(255,255,255,0.1);"
                  >
                    <img
                      :src="config.STORAGE_URL + owner.company.logo"
                      alt="Logo"
                      style="max-width: 100%; max-height: 100%; object-fit: contain;"
                    />
                  </div>
                  <div class="flex-grow-1">
                    <div class="custom-file">
                      <input
                        type="file"
                        class="custom-file-input"
                        id="companyLogo"
                        @change="handleFileChange"
                        accept="image/*"
                      />
                      <label class="custom-file-label bg-dark text-muted border-secondary" for="companyLogo">
                        {{ selectedLogoName || ($currentLocale === 'id' ? 'Ganti logo perusahaan...' : 'Replace company logo...') }}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Action Buttons -->
            <div class="d-flex justify-content-end align-items-center pt-3 border-top border-secondary">
              <button
                type="button"
                @click="back"
                class="btn btn-outline-secondary px-4 py-2 mr-3"
                :disabled="loading"
              >
                {{ $t('common.cancel') }}
              </button>
              <button
                type="submit"
                class="btn btn-warning px-5 py-2 font-weight-bold text-dark"
                :disabled="loading"
              >
                <span v-if="loading" class="spinner-border spinner-border-sm mr-2" role="status"></span>
                <i v-else class="mdi mdi-check-circle-outline mr-1"></i>
                {{ loading ? $t('common.saving') : $t('common.update') }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { updateOwner, getDetailOwner } from '@/services/ownerService';
import config from '@/config/config';
import Swal from 'sweetalert2';

export default {
  name: 'EditOwnerView',
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    ownerStore: {
      companyName: '',
      ownerName: '',
      emailAddress: '',
      phoneNumber: '',
      password: '',
      companyLogo: null,
    },
    owner: null,
    selectedLogoName: '',
    config,
    loading: false,
  }),
  mounted() {
    this.fetchDetailOwner();
  },
  methods: {
    fetchDetailOwner() {
      getDetailOwner(this.id).then((response) => {
        this.owner = response;
        this.ownerStore.companyName = (response.company && response.company.name) || '';
        this.ownerStore.ownerName = response.name || '';
        this.ownerStore.emailAddress = response.email || '';
        this.ownerStore.phoneNumber = response.phone_number || '';
        this.ownerStore.password = '';
        this.ownerStore.companyLogo = null;
      });
    },
    handleFileChange(event) {
      if (event.target.files.length > 0) {
        this.ownerStore.companyLogo = event.target.files[0];
        this.selectedLogoName = event.target.files[0].name;
      } else {
        this.ownerStore.companyLogo = null;
        this.selectedLogoName = '';
      }
    },
    async submitForm() {
      this.loading = true;
      try {
        const payload = {
          ...this.ownerStore,
          company_name: this.ownerStore.companyName,
          name: this.ownerStore.companyName,
          owner_name: this.ownerStore.ownerName,
          email: this.ownerStore.emailAddress,
          email_address: this.ownerStore.emailAddress,
          phone_number: this.ownerStore.phoneNumber,
        };
        await updateOwner(this.id, payload);

        Swal.fire({
          icon: 'success',
          title: this.$t('common.success'),
          text: this.$currentLocale === 'id' ? 'Profil perusahaan berhasil diperbarui.' : 'Enterprise profile updated successfully',
          confirmButtonColor: '#ffab00',
        });

        this.$router.push({ name: 'DetailOwner', params: { id: String(this.id) } });
      } catch (error) {
        const errors = error.response?.data?.errors;
        const errMsg =
          errors && typeof errors === 'object'
            ? Object.values(errors).flat()[0]
            : error.response?.data?.message || error.message || (this.$currentLocale === 'id' ? 'Gagal memperbarui profil perusahaan' : 'Failed to update enterprise profile');

        Swal.fire({
          icon: 'error',
          title: this.$t('common.error'),
          text: errMsg,
          confirmButtonColor: '#ffab00',
        });
      } finally {
        this.loading = false;
      }
    },
    back() {
      this.$router.go(-1);
    },
  },
};
</script>
